import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var AlertBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-left: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  padding: ", "px;\n  display: flex;\n  align-items: center;\n  gap: ", "px;\n"], ["\n  background: ", ";\n  border-left: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  padding: ", "px;\n  display: flex;\n  align-items: center;\n  gap: ", "px;\n"])), function (props) {
  var _a;

  return props.background || ((_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.blueLight);
}, function (props) {
  var _a;

  return "".concat((_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.infoBlockBorderWidth, "px solid ").concat(props.borderColor);
}, function (props) {
  var _a, _b;

  return "".concat((_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.borderRadius.extraSmall, "px 0 0 ").concat((_b = props.theme.attributes) === null || _b === void 0 ? void 0 : _b.borderRadius.extraSmall, "px");
}, function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.boxShadow.layoutShadow;
}, function (props) {
  return props.padding;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.sm;
});
var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: ", "px;\n  display: flex;\n  align-items: center;\n"], ["\n  min-width: ", "px;\n  display: flex;\n  align-items: center;\n"])), function (props) {
  var _a;

  return props.minWidth || ((_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.md);
});
var templateObject_1, templateObject_2;
export { AlertBox, IconContainer };